// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { formikInjectedPropsTypes } from '../../../lib/validation/propTypes/formikPropTypes';

import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

// Components
import { InputCheckbox, Trans, InputRadioGroup } from '../..';
import { LoadingDots } from '../../common';
import { AddPaymentCard, PaymentCard } from '..';
import { EditPaymentAccountModal } from '../../common/modals';
import { WhatsThisModal } from '../../common/modals';
import { TxPaymentCardForm, TxPaymentCardFormMode } from 'texkit-ui/forms';

import { PaymentCardFormWrapper } from '../';

// Selectors
import { selectPaymentAccounts } from '../../../reducers/payment/paymentSelectors';

// Actions
import { openModal } from '../../../reducers/modal/modalActions';

// Helpers
import { isDateExpired } from '../../../lib/helpers/util';

const PaymentSelectCardList = ({
  formikProps,
  onCardFieldMessage,
  onChange = () => {},
  onFormError = () => {},
  onFormFilled = () => {},
}) => {
  const dispatch = useDispatch();
  const paymentAccounts = useSelector(selectPaymentAccounts);
  const setFieldValue = formikProps.setFieldValue;
  const { selectedLanguage } = useSelector(({ language }) => ({
    selectedLanguage: language.selected,
  }));

  if (!paymentAccounts) {
    return <LoadingDots />;
  }

  const inputOptions = paymentAccounts.map((paymentAccount, index) => {
    const isCardSelected =
      formikProps.values.selectPayment &&
      formikProps.values.selectPayment.paymentAccountId ===
        paymentAccount.paymentAccountId;

    const isCardExpired = isDateExpired(paymentAccount.expirationDate);
    const showCvv = isCardSelected && paymentAccount.cvvRequired;

    const onEdit = () => {
      dispatch(openModal('EditPaymentAccountModal', { paymentAccount }));
    };

    return {
      className: classNames('payment-select-list-item', {
        'selected-payment': isCardSelected,
        disabled: isCardExpired,
      }),
      id: `selectPayment${index}`,
      value: paymentAccount,
      disabled: isCardExpired,
      label: (
        <PaymentCard
          paymentAccount={paymentAccount}
          formikProps={formikProps}
          showCvv={showCvv}
          showEditButton={true}
          onEdit={onEdit}
          isCardExpired={isCardExpired}
        />
      ),
    };
  });

  inputOptions.push({
    className: classNames('payment-select-list-item', 'add-card-item', {
      'selected-payment':
        formikProps.values.selectPayment.paymentAccountId === 'addcard',
    }),
    id: `selectPayment${inputOptions.length}`,
    value: {
      paymentAccountId: 'addcard',
    },
    label: <AddPaymentCard />,
  });

  const onChangeCallback = event => {
    formikProps.resetForm();
    if (setFieldValue) {
      if (formikProps.values.cvv) {
        setFieldValue('cvv', '');
      }
    }

    const paymentAccountId = event.target.value;
    const paymentAccount = paymentAccounts.find(
      account => account.paymentAccountId === paymentAccountId
    );

    onChange(paymentAccount);
  };

  return (
    <>
      <div className="payment-select">
        <div className="payment-select-list">
          {inputOptions && inputOptions.length > 0 && (
            <InputRadioGroup
              name="selectPayment"
              optionValueKey="paymentAccountId"
              formikProps={formikProps}
              options={inputOptions}
              onChange={onChangeCallback}
            />
          )}
          {formikProps.values.selectPayment.paymentAccountId === 'addcard' && (
            <>
              <div className="add-card-form">
                <PaymentCardFormWrapper formikProps={formikProps}>
                  <TxPaymentCardForm
                    displayName="TxPaymentCardForm"
                    billingAddressTitle={
                      <Trans file="Payment" id="BillingAddressTitle" />
                    }
                    billingAddressSubTitle={
                      <Trans file="Payment" id="BillingAddressSubTitle" />
                    }
                    paymentMethodTitle={
                      <Trans file="Payment" id="CardInformationTitle" />
                    }
                    paymentMethodSubTitle={
                      <Trans file="Payment" id="PaymentMethodSubTitle" />
                    }
                    mode={TxPaymentCardFormMode.TransactionAdd}
                    onCardFieldMessage={onCardFieldMessage}
                    spanish={selectedLanguage === 'es'}
                    onFormError={onFormError}
                    onFormFilled={onFormFilled}
                  />
                </PaymentCardFormWrapper>
              </div>
              <InputCheckbox
                formikProps={formikProps}
                className="saveCardCheckbox addCard"
                name="savePaymentAccount"
                label={<Trans file="Payment" id="SaveCardToAccount" />}
                // DFCT0035994 - ADA ISSUE
                aria-label="Save card to wallet for future use"
                aria-checked={formikProps.values.savePaymentAccount || false}
              />
            </>
          )}
        </div>
      </div>
      <EditPaymentAccountModal />
      <WhatsThisModal />
    </>
  );
};

PaymentSelectCardList.propTypes = {
  formikProps: formikInjectedPropsTypes.isRequired,
  onCardFieldMessage: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onFormFilled: PropTypes.func,
  onFormError: PropTypes.func,
};

export default PaymentSelectCardList;
